'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AddressSuggestion;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _P = require('../../P');

var _P2 = _interopRequireDefault(_P);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  'suggestion': 'ccl-f0ec83d50f28de59',
  'highlighted': 'ccl-f5a774c0391c566d',
  'button': 'ccl-224a39591f0cfb3e'
};

/**
 * An Address Suggestion for the LocationSearch component.
 */

function AddressSuggestion(_ref) {
  var address = _ref.address,
      _ref$locality = _ref.locality,
      locality = _ref$locality === undefined ? '(' + address + ')' : _ref$locality,
      isHighlighted = _ref.isHighlighted,
      onClick = _ref.onClick;

  return _react2.default.createElement(
    'li',
    { className: (0, _classnames3.default)(styles.suggestion, _defineProperty({}, styles.highlighted, isHighlighted)) },
    _react2.default.createElement(
      'button',
      { type: 'button', className: styles.button, onClick: onClick },
      _react2.default.createElement(
        _P2.default,
        { size: 'small' },
        address
      ),
      _react2.default.createElement(
        _P2.default,
        { size: 'x-small', color: 'grey' },
        locality
      )
    )
  );
}

AddressSuggestion.displayName = 'AddressSuggestion';
AddressSuggestion.propTypes = {
  /**
   * The formatted address string.
   */
  address: _propTypes2.default.string.isRequired,

  /**
   * The locality of the address, e.g. city
   */
  locality: _propTypes2.default.string,

  /**
   * If the address is highlighted.
   */
  isHighlighted: _propTypes2.default.bool,

  /**
   * Click handler for the address
   */
  onClick: _propTypes2.default.func.isRequired
};

AddressSuggestion.defaultProps = {
  isHighlighted: false,
  locality: undefined
};